"use client";

import React from "react";
import { Phone, MessageCircle, Info, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const cardsData = [{
    title: "הפתרון המהיר שלנו",
    content: "אנו ב-Siudy סיעוד מיידי מציעים פתרון קצה לקצה הכולל התאמת מטפל סיעודי תוך 5 שעות בלבד. השירות שלנו מיועד למשפחות הזקוקות לשקט נפשי מיידי בבית או בבית החולים."
  }, {
    title: "יתרונות השירות",
    content: "הצוות שלנו מורכב מ-ישראלים בלבד, מה שמבטיח תקשורת רציפה, הבנה תרבותית וטיפול מסור ברמה הגבוהה ביותר. זמינות מיידית היא הערך המוביל שלנו."
  }, {
    title: "מידע מפורט",
    content: "כל מטפל סיעודי עובר סינון קפדני הכולל בדיקת רקע, המלצות והכשרה מקצועית. אנו מלווים אתכם לאורך כל הדרך עם זמינות מלאה לכל שאלה."
  }];
  const faqData = [{
    question: "כמה זמן לוקח למצוא מטפל סיעודי?",
    answer: "בזכות המערך הארצי שלנו, אנו מתחייבים למצוא ולהציב מטפל סיעודי תוך 5 שעות בלבד מרגע הפנייה."
  }, {
    question: "האם אתם מעסיקים ישראלים בלבד?",
    answer: "כן, המדיניות שלנו ברורה: רק מטפלים ישראלים בלבד מצטרפים לצוות שלנו, כדי להבטיח את איכות השירות והתקשורת עם המטופל."
  }, {
    question: "האם השירות זמין גם בסופי שבוע?",
    answer: "בוודאי. סיעוד מיידי פועל במתכונת של זמינות מיידית 24/7, כולל שבתות וחגים, לכל צורך דחוף."
  }];
  return <section data-section-id="210354" id="קריאה-לפעולה" className="relative py-20 md:py-32 bg-primary overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_center,var(--color-ring)_0%,transparent_70%)] pointer-events-none" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 max-w-5xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]"}`}>
        <p className="font-sans text-ring font-medium mb-4 tracking-wide uppercase text-sm md:text-base">
          זקוקים לעזרה? סיעוד מיידי כאן עבורכם עם מטפל סיעודי מקצועי
        </p>

        <h2 className="font-default text-3xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-6 tracking-tight">
          צריך מטפל עכשיו? אנחנו בדרך
        </h2>
        
        <div className="font-sans text-lg md:text-xl text-primary-foreground/90 mb-12 max-w-3xl mx-auto leading-relaxed text-right md:text-center">
          <p className="mb-4">
            מציאת <Link to="/CaregiverServicePagesPage" className="text-ring hover:underline font-bold">מטפל סיעודי</Link> איכותי ברגע של משבר היא אתגר מורכב. ניתן למצוא פתרון מהיר עבור <Link to="/NurseInTelAvivWithinHoursPage" className="text-ring hover:underline">מטפל סיעודי בתל אביב</Link> ובסביבתה, כולל שירות של <Link to="/NurseInTelAvivWithinHoursPage" className="text-ring hover:underline">מטפל סיעודי בתל אביב</Link>. השירות של **סיעוד מיידי** הוקם כדי לתת מענה בדיוק לרגעים אלו, עם **זמינות מיידית** בכל רחבי הארץ, כולל אפשרות להזמנת <Link to="/NursingCareProviderInHaifaWithinHoursPage" className="text-ring hover:underline">מטפל סיעודי בחיפה</Link>. אנו מספקים **מטפל סיעודי** מקצועי, כאשר כל הצוות שלנו מורכב מ**ישראלים בלבד** כדי להבטיח תקשורת רציפה והבנה תרבותית, כפי שניתן לראות במאמר על <Link to="/ProfessionalBlogPage" className="text-ring hover:underline">יתרונות הטיפול הביתי</Link>.
          </p>
          <p>
            הפתרון שלנו מאפשר לכם לקבל <Link to="/CaregiverServicePagesPage" className="text-ring hover:underline font-bold">מטפל סיעודי</Link> לבית או לבית החולים **תוך 5 שעות** מרגע הפנייה. היתרונות של **סיעוד מיידי** כוללים שקט נפשי, טיפול מסור וליווי צמוד. אנו מספקים מענה נרחב הכולל <Link to="/NursingCareProviderInHaifaWithinHoursPage" className="text-ring hover:underline">מטפל סיעודי בחיפה</Link> וכן <Link to="/NursingCareProviderInJerusalemWithinFiveHoursPage" className="text-ring hover:underline">מטפל סיעודי בירושלים</Link> ובמוקדים נוספים. אם אתם מחפשים **מטפל סיעודי** שלא מתפשר על איכות, הגעתם למקום הנכון – אנו נדאג שכל **מטפל סיעודי** שתקבלו יהיה המקצועי ביותר בתחום, כפי שמוסבר במדריך <Link to="/ProfessionalBlogPage" className="text-ring hover:underline">איך לבחור מטפל סיעודי</Link> בצורה נכונה וכן במאמר <Link to="/ProfessionalBlogPage" className="text-ring hover:underline">יתרונות הטיפול הביתי</Link>.
          </p>
          <p className="mt-4">
            אנו זמינים במגוון <Link to="/CaregiverServicePagesPage2" className="text-ring hover:underline">אזורים נוספים</Link> בכל רחבי הארץ.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {cardsData.map((card, i) => <div key={i} data-index={i} className="bg-card text-card-foreground border border-border rounded-2xl p-6 shadow-lg text-right transition-transform hover:-translate-y-1 duration-300">
              <h3 className="text-xl font-bold text-primary mb-3">{card.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {card.content}
              </p>
            </div>)}
        </div>

        {}
        <div className="max-w-3xl mx-auto mb-16 text-right">
          <h3 className="text-2xl font-bold text-primary-foreground mb-8 text-center">שאלות נפוצות על השירות שלנו</h3>
          <div className="space-y-4">
            {faqData.map((faq, i) => <div key={i} data-index={i} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-5">
                <div className="flex items-center justify-between gap-4 cursor-default">
                  <span className="font-bold text-primary-foreground text-lg">{faq.question}</span>
                  <ChevronDown className="size-5 text-ring shrink-0" />
                </div>
                <p className="mt-3 text-primary-foreground/80 text-sm md:text-base leading-relaxed">
                  {faq.answer}
                </p>
              </div>)}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-lg bg-ring text-primary-foreground hover:bg-ring/90 h-14 px-8 text-lg font-medium transition-all hover:scale-105">
            <Link to="tel:0723972382">
              <Phone className="ml-2 size-5" />
              התקשרו עכשיו
            </Link>
          </Button>

          <Button asChild size="lg" className="w-full sm:w-auto rounded-lg bg-chart-2 text-primary-foreground hover:bg-chart-2/90 h-14 px-8 text-lg font-medium relative group transition-all hover:scale-105 border-0">
            <Link to="https://wa.me/972501234567" newTab>
              <span className="absolute inset-0 rounded-lg bg-chart-2 animate-ping opacity-20 group-hover:opacity-30 transition-opacity duration-300" />
              <MessageCircle className="ml-2 size-5 relative z-10" />
              <span className="relative z-10">וואטסאפ</span>
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-lg border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary h-14 px-8 text-lg font-medium transition-all hover:scale-105">
            <Link to="/CaregiverServicePagesPage">
              <Info className="ml-2 size-5" />
              מידע נוסף
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}